export const colorsAutocontrole = {
    primary: '#7D1E4F',
    secondary: '#CBA5B9',
    tier: '#C4CCE5',
    disabled: '#C0B9C0',
    default: '#D6D1D6',
    checkboxDefault: '#252225',
    sliderRailDisabled: '#121212'
}